export const getFileTypeFromBase64 = (
  base64String?: string,
): "IMAGE" | "PDF" | undefined => {
  if (!base64String) return undefined;

  try {
    // Get first 20 characters to check magic numbers
    const binaryString = atob(base64String.substring(0, 20));
    const firstBytes = binaryString.substring(0, 8);

    // Check for PDF signature (%PDF-)
    if (firstBytes.includes("%PDF")) {
      return "PDF";
    }
    return "IMAGE";
  } catch (error) {
    console.error("Error detecting file type from base64:", error);
    return undefined;
  }
};

// Helper function to get file type from extension
export const getFileTypeFromName = (
  fileName?: string,
): "IMAGE" | "PDF" | undefined => {
  if (!fileName) return undefined;

  const extension = fileName.split(".").pop()?.toLowerCase();

  if (["pdf"].includes(extension || "")) {
    return "PDF";
  }

  if (
    ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg", "ico"].includes(
      extension || "",
    )
  ) {
    return "IMAGE";
  }

  return undefined;
};
